/**
 * Permisos generales (patrón SGDEA): pocos y de alcance amplio. Lo que alguien puede hacer con un proyecto concreto
 * lo decide su rol en ese proyecto (`ProjectRole`), no un permiso por acción.
 */
export const Permission = {
    /** Crear proyectos y espacios. */
    PROJECT_CREATE: 'project.create',
    /** Ver todos los proyectos, también los privados (Auditor, Administrador). */
    PROJECT_READ_ALL: 'project.read.all',
    REPORTS_READ: 'reports.read',
    AUDIT_READ: 'audit.read',
    /** Usuarios, roles, equipos, etiquetas, plantillas. */
    ADMIN_MANAGE: 'admin.manage',
    /** Módulos, motor de decisión, seguridad. */
    ADMIN_ADVANCED: 'admin.advanced',
    GOALS_MANAGE: 'goals.manage',
    EXTERNAL_MANAGE: 'external.manage',
    CORRECTIVE_MANAGE: 'corrective.manage',
    RISKS_MANAGE: 'risks.manage',
    MEETINGS_MANAGE: 'meetings.manage',
};
export const ALL_PERMISSIONS = Object.values(Permission);
export const PERMISSION_LABEL = {
    'project.create': 'Crear proyectos',
    'project.read.all': 'Ver todos los proyectos',
    'reports.read': 'Ver reportes',
    'audit.read': 'Ver la auditoría',
    'admin.manage': 'Administrar usuarios y catálogos',
    'admin.advanced': 'Administración avanzada (módulos, motor de decisión)',
    'goals.manage': 'Gestionar objetivos',
    'external.manage': 'Gestionar colaboradores externos',
    'corrective.manage': 'Gestionar acciones correctivas',
    'risks.manage': 'Gestionar riesgos',
    'meetings.manage': 'Gestionar reuniones',
};
/** Roles del sistema. ADMIN y AUDITOR están bloqueados: sus permisos no se editan. */
export const SystemRole = { ADMIN: 'ADMIN', AUDITOR: 'AUDITOR', MEMBER: 'MEMBER', EXTERNAL: 'EXTERNAL' };
export const LOCKED_ROLE_PERMISSIONS = {
    ADMIN: ALL_PERMISSIONS,
    AUDITOR: [Permission.PROJECT_READ_ALL, Permission.REPORTS_READ, Permission.AUDIT_READ],
};
export const DEFAULT_ROLES = [
    { code: 'ADMIN', name: 'Administrador', description: 'Todo, incluida la configuración', permissions: ALL_PERMISSIONS },
    { code: 'AUDITOR', name: 'Auditor', description: 'Lectura transversal y auditoría, sin alterar el trabajo', permissions: LOCKED_ROLE_PERMISSIONS.AUDITOR },
    { code: 'MEMBER', name: 'Miembro', description: 'Crea proyectos y trabaja en los que lo inviten', permissions: [Permission.PROJECT_CREATE, Permission.REPORTS_READ] },
    { code: 'EXTERNAL', name: 'Externo', description: 'Solo ve los proyectos y tareas que le comparten', permissions: [] },
];
/** Rol de una persona en un proyecto (MeisterTask: Content Manager, Contributor, Guest, Commenter, Viewer). */
export const ProjectRole = { MANAGER: 'MANAGER', CONTRIBUTOR: 'CONTRIBUTOR', GUEST: 'GUEST', COMMENTER: 'COMMENTER', VIEWER: 'VIEWER' };
export const PROJECT_ROLE_LABEL = { MANAGER: 'Gestor', CONTRIBUTOR: 'Colaborador', GUEST: 'Invitado', COMMENTER: 'Comentarista', VIEWER: 'Lector' };
export const PROJECT_ROLE_CAPABILITIES = {
    MANAGER: ['view', 'viewAll', 'comment', 'editTasks', 'manage'],
    CONTRIBUTOR: ['view', 'viewAll', 'comment', 'editTasks'],
    // El invitado solo ve las tareas donde es responsable u observador, y puede trabajarlas.
    GUEST: ['view', 'comment', 'editTasks'],
    COMMENTER: ['view', 'viewAll', 'comment'],
    VIEWER: ['view', 'viewAll'],
};
//# sourceMappingURL=permissions.js.map